export const medicoes = [
  {
    id: 'ecb7253e-6eb4-4371-8bda-9073b5c9eb60',
    numero: 1,
    periodoFim: '30/09/2019',
    periodoInicio: '01/09/2019',
    dataHoraUltimaTrocaStatusAutorizacaoPagamento: '2019-10-04T20:09:51.4576933',
    ultimaTrocaStatus: '2019-10-04T20:09:51.4576933',
    possuiSla: true,
    statusMedicaoId: '7ab966c9-bc59-4be4-b77e-72ceff0c1b1f',
    desrciaoStatusMedicao: 'Concluído',
    nomeDoFornecedor: 'VETTA GROUP S.A.',
    numeroDoContrato: '900002',
    statusAutorizacaoPagamentoId: '120fad5a-aefc-48e1-89ac-bd29e0e4aa72',
    descricaoStatusAutorizacaoPagamento: '',
  },
];

export const itensMedicoes = [
  {
    id: 'a0a7e068-3280-4ca5-9799-973084f9c445',
    medicaoId: 'ecb7253e-6eb4-4371-8bda-9073b5c9eb60',
    item: '1',
    descricao: 'CONSTRUÇÃO DO SISTEMA',
    unidade: '',
    quantidade: '',
    preco: '',
    verbaTotal: '45000,0000',
    editable: false,
    aprovadoString: '0',
    children: [
      {
        id: 'e54f82fb-190a-408e-8259-4625ec32eaa5',
        medicaoId: '00000000-0000-0000-0000-000000000000',
        item: '1.1',
        descricao: 'ESPECIFICAÇÃO',
        unidade: 'hr',
        quantidade: '1,0000',
        preco: '500,0000',
        verbaTotal: '500,0000',
        qt_bl_anterior: '0,0000',
        qt_bl_periodo: '0,0000',
        qt_bl_acumulado: '0,0000',
        qt_bl_saldo: '0,0000',
        vl_bl_anterior: '0,0000',
        vl_bl_periodo: '0,0000',
        vl_bl_acumulado: '',
        vl_bl_saldo: '0,0000',
        vl_bl_saldoPorcentagem: '0,0000',
        editable: true,
        numeroLinha: 13,
        aprovado: true,
        aprovadoString: 'Aprovado',
        children: [],
      },
      {
        id: '53970d74-ff51-4dbc-9906-c8268ee5bfdf',
        medicaoId: '00000000-0000-0000-0000-000000000000',
        item: '1.2',
        descricao: 'DESENVOLVIMENTO',
        unidade: 'hr',
        quantidade: '10,0000',
        preco: '450,0000',
        verbaTotal: '4500,0000',
        qt_bl_anterior: '0,0000',
        qt_bl_periodo: '66,6701',
        qt_bl_acumulado: '66,6701',
        qt_bl_saldo: '-66,6701',
        vl_bl_anterior: '0,0000',
        vl_bl_periodo: '30001,5225',
        vl_bl_acumulado: '',
        vl_bl_saldo: '-30001,5225',
        vl_bl_saldoPorcentagem: '-666,7005',
        editable: true,
        numeroLinha: 14,
        aprovado: true,
        aprovadoString: 'Aprovado',
        children: [],
      },
      {
        id: '346b391c-2cd7-42fc-9a0c-d7a06ebede69',
        medicaoId: '00000000-0000-0000-0000-000000000000',
        item: '1.3',
        descricao: 'TESTES',
        unidade: 'hr',
        quantidade: '40,0000',
        preco: '1000,0000',
        verbaTotal: '40000,0000',
        qt_bl_anterior: '0,0000',
        qt_bl_periodo: '0,0000',
        qt_bl_acumulado: '0,0000',
        qt_bl_saldo: '0,0000',
        vl_bl_anterior: '0,0000',
        vl_bl_periodo: '0,0000',
        vl_bl_acumulado: '',
        vl_bl_saldo: '0,0000',
        vl_bl_saldoPorcentagem: '0,0000',
        editable: true,
        numeroLinha: 15,
        aprovado: true,
        aprovadoString: 'Aprovado',
        children: [],
      },
    ],
  },
];

export const medicao = {
  id: 'ecb7253e-6eb4-4371-8bda-9073b5c9eb60',
  numero: 1,
  status: 'Concluído',
  tipo: 'Manual',
  final: false,
  possuiSla: true,
  fornecedor: 'VETTA GROUP S.A.',
  numeroDoContrato: '900002',
  numeroDoAditivo: '4',
  periodoInicio: '2019-09-01T20:11:16.397',
  periodoFim: '2019-09-30T20:11:19.895',
  statusConcluido: false,
  reprovarDadosQuantitativos: false,
  confirmarQuantidadeDoBm: false,
  aprovarAnaliseQuantitativaBm: false,
  reprovarAnaliseQuantitativaBm: false,
  aprovarComRessalvaAnaliseQuantitativa: false,
  refutarAnaliseQuantitativa: false,
  reconfirmarQuantidadeBm: false,
  aprovarDadosBM: false,
  aprovarDadosBmComRessalva: false,
  refutarMedicao: false,
  confirmarMedicao: false,
  solicitarCancelamentoBoletimMedicao: false,
  aprovarCancelamentoBm: false,
  reprovarCancelamentoBm: false,
};

export const anexoMedicao = [
  {
    id: '54f42c72-d045-481d-b082-7b5380ed86a8',
    numero: 4,
    nomeDoArquivo: 'Exemplo MRN - PQ PREENCHIDA - VETTA.xlsx',
    dataHoraInclusao: '04/10/2019',
    responsavel: '',
  },
  {
    id: '3578ba82-053e-4a3a-984a-d799a02ddbb4',
    numero: 3,
    nomeDoArquivo: 'RN-04-06.xlsx',
    dataHoraInclusao: '04/10/2019',
    responsavel: '',
  },
  {
    id: '2cb7d710-dfb1-4536-9945-7e9ac70ce298',
    numero: 2,
    nomeDoArquivo: 'RN-04-04.xlsx',
    dataHoraInclusao: '04/10/2019',
    responsavel: '',
  },
  {
    id: '67dc376e-ec30-409c-812d-9090f181412b',
    numero: 1,
    nomeDoArquivo: 'TESTE-FLUXO-1.xlsx',
    dataHoraInclusao: '04/10/2019',
    responsavel: '',
  },
];
